export class HealthDetails {
  anyHealthConditions: string = '';
  anyCrime: string = '';
  refusedVisa: string = '';
  cancelledVisa: string = '';
}